const subsystemStoreModule = {
  namespaced: true,
  state: () => ({
    subsystem: null,
  }),
  mutations: {
    setSubsystem(state, subsystem) {
      state.subsystem = subsystem
    },
  },
  getters: {
    subsystem: state => state.subsystem,
  },
}

export default subsystemStoreModule
